import { FormControl as FormControlMain, FormControlProps, FormHelperText } from "@mui/material";
import { ReactNode } from "react";
import { useController } from "react-hook-form";

import { useDescriptionField } from "../hooks/useDescriptionField";
import { useErrorMessage } from "../hooks/useErrorMessage";
import { useFormContext } from "../hooks/useFormContext";

import { useFormControlStyles } from "./FormControl.styles";

interface IProps extends FormControlProps {
	name: string;
	children: ReactNode;
	isHideErrorField?: boolean;
	isHideError?: boolean;
}

export const FormControl = ({
	name,
	children,
	isHideErrorField,
	isHideError,
	...props
}: IProps) => {
	const { classes, cx } = useFormControlStyles();
	const getTranslateError = useErrorMessage();
	const { control } = useFormContext();
	const {
		fieldState: { invalid, error },
	} = useController({ name, control });

	const { required } = useDescriptionField(name);

	return (
		<FormControlMain error={invalid} required={required} {...props}>
			{children}
			{(error || !isHideErrorField) && !isHideError && (
				<FormHelperText className={cx(classes.helperText, isHideErrorField && classes.removeField)}>
					{error?.message && getTranslateError(error?.message)}
				</FormHelperText>
			)}
		</FormControlMain>
	);
};
